import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import Placeholder from 'Components/Placeholder';

import Login from 'Edits/Login';

registerBlockType('eformv4/login', {
	title: __('Login Form - eForm', 'ipt_fsqm'),
	icon: 'admin-network',
	category: 'eform-v4',
	attributes: {
		...eFormGTB.attributes.login,
	},

	edit({ attributes, className, setAttributes }) {
		const title = __('Styled Login Form', 'ipt_fsqm');
		const message = __(
			'A simple login form styled with eForm themes',
			'ipt_fsqm'
		);

		return (
			<Placeholder className={className} title={title} message={message}>
				<Login {...{ attributes, setAttributes }} />
			</Placeholder>
		);
	},

	save() {
		return null;
	},
});
